import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import {
    CheckResetToken,
    CheckResetTokenPayload,
} from 'app/types/auth/resetPassword'

export const checkResetPasswordToken = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.CHECK_RESET_PASSWORD_TOKEN}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = CheckResetTokenPayload.safeParse(payload)

        // Wrong payload
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<CheckResetToken>({
            is_valid: true,
        })
    },
)
